module.exports = __webpack_public_path__ + "media/assets/faria_products/OASD-bf7c93640f4585f3fc294e01172f60c3e6c7ad994ab5391c94114d34101b15a0.png";